import {
    pp,
    link,
    formatDate
} from '@helpers'
// import { skillStore } from '@stores'

export const useAuthStore = {

    state: () /* : State */ => ({

        // $_user: {},

        email: '',
        password: '',
        remember: false,

        // validator: null,

        // confirm_logout: false,

        // loadingLogin: false,

        // messageError: '',
        msgError401Already: false, // used in  notify.error()  &  Login.vue

        // secondsAttempsCountDown: 180,
        // countDownAttemps: null,

        // fromReauthentication: false,
        // sessionExpired: false,
        // session_token: '', // uniquement si l'user doit se reconnecter (in auth/ReAuthentication.vue)


        // count_before_auto_deconnect: 0 // utilisé dans main.js
    }),

    // getters: {

    // },

    actions: {

        async logout(auto_disconnect = false) {

            //   log('in store/auth@logout()',pp, pp(), $q)

            if (pp().user) {

                // const sk_state = skillStore().$state

                await axios.post(route('logout'))

                // sk_state.supervised = null

                var prev = route().current() // util if auto_disconnect

                // var params = _.toArray(route().params)//''
                var params = ''

                _.each(route().params, (v, k) => {
                    if (v) {
                        // params += `${k}.${v}|`
                        params += `${k}.${v}|`
                        // params[k] = v // NON
                    }
                })

                if (auto_disconnect) {
                    // log('in auth/logout()', params, route())
                    //? capté et supprimé dans  Login.vue
                    $q.cookies.set('notify_auto_disconnect', {
                        msg: `Vous avez été déconnecté(e) pour cause d'inactivité pendant plus de ${(pp()?.session_lifetime - 5)} minutes.`,
                        caption: 'le ' + formatDate({
                            withHour: true
                        })
                    })
                }


                link(route('login-view'))// + '?redirect=' + prev + '&params=' + params)
                // link(route('login'))// + '?redirect=' + prev + '&params=' + params)

                // if(auto_disconnect){

                //     // location.assign('/login-view' + '?redirect='+prev + '&params='+params) // pour éviter la 419 - Page Expirée

                //     fn.notify('info',"Vous avez été déconnecté(e) pour cause d'inactivité.",'',0)

                // }
                // else {
                //     fn.link(fn.route('login-view'))
                // }


            }

            // proto.$inertia
            //         // .post(fn.route('logout'))
            //     .post(fn.route('logout'), {
            //         preserveState: false,
            //         onFinish: () => {

            //             fn.link(fn.route('login-view'))

            //         }
            //     })
        },
    }
}
